// FormikDropdown.tsx
import React from 'react';
import { useField } from 'formik';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

interface Option {
  value: string | number;
  label: string;
}

interface FormikDropdownProps {
  name: string;
  options: Option[];
  label?: string;
  placeholder?: string;
  className?: string;
  onChange?: (value: string | number) => void;
}

export const FormikDropdown: React.FC<FormikDropdownProps> = ({
  name,
  options,
  label,
  placeholder,
  className,
  onChange,
}) => {
  const [field, meta, helpers] = useField(name);

  const selectId = `${name}-select`;

  const handleChange = (event: any) => {
    const value = event.target.value;
    helpers.setValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <FormControl
      fullWidth // Genişliği kapsayıcısına göre ayarla
      error={meta.touched && Boolean(meta.error)} // Formik hatasını MUI error prop'una bağla
      className={className} // Dışarıdan gelen className'i uygula
    >
      {label && <InputLabel id={`${selectId}-label`}>{label}</InputLabel>} {/* Label */}
      <Select
        labelId={`${selectId}-label`} // Label ile eşleştir
        id={selectId} // ID tanımla
        {...field} // Formik field props'larını uygula (value, onChange, onBlur)
        onChange={handleChange}
        label={label} // Select'in label prop'u (outlined varyant için)
        displayEmpty={!!placeholder} // Placeholder varsa boş değeri göster
      >
        {placeholder && (
          <MenuItem value="" disabled>
            {' '}
            {/* Placeholder seçeneği */}
            {placeholder}
          </MenuItem>
        )}
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {' '}
            {/* Seçenekler */}
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && <FormHelperText>{meta.error}</FormHelperText>}{' '}
      {/* Hata mesajı */}
    </FormControl>
  );
};
